module.exports = __webpack_public_path__ + "img/sunshine.0da229f8.svg";